import {Component} from '@angular/core';
import {systemName} from "../../../store/base.entity";

@Component({
  selector: 'app-guest-footer',
  templateUrl: './guest-footer.component.html',
  styleUrl: './guest-footer.component.scss'
})
export class GuestFooterComponent {
  currentYear = new Date().getFullYear();

  protected readonly systemName = systemName;
}
